"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./ButtonGroup.scss");
var key_press_1 = require("../../../utils/key-press");
var ButtonGroup = /** @class */ (function (_super) {
    __extends(ButtonGroup, _super);
    function ButtonGroup(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.state = {
            hoverArr: props.data.map(function () { return false; }),
            isTouching: false,
            selectedIndex: ((_a = props.options) === null || _a === void 0 ? void 0 : _a.defaultSelected) ? props.options.defaultSelected : 0,
            uniqueId: _this.guid(),
            width: 0,
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.onKeyUp = _this.onKeyUp.bind(_this);
        _this.onMouseLeave = _this.onMouseLeave.bind(_this);
        _this.onMouseOver = _this.onMouseOver.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        _this.onTouchEnd = _this.onTouchEnd.bind(_this);
        _this.updateWidth = _this.updateWidth.bind(_this);
        _this.guid = _this.guid.bind(_this);
        _this.S4 = _this.S4.bind(_this);
        return _this;
    }
    ButtonGroup.prototype.componentDidMount = function () {
        this.updateWidth();
        this.setState({ uniqueId: this.guid() });
        window.addEventListener("resize", this.updateWidth);
    };
    ButtonGroup.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.updateWidth);
    };
    ButtonGroup.prototype.onKeyDown = function (e) {
        if (key_press_1.KeyPress.enterIsPressed(e) ||
            key_press_1.KeyPress.spaceIsPressed(e) ||
            key_press_1.KeyPress.leftArrowIsPressed(e) ||
            key_press_1.KeyPress.rightArrowIsPressed(e)) {
            e.preventDefault();
        }
    };
    ButtonGroup.prototype.onKeyUp = function (e) {
        var _a = this.props, data = _a.data, events = _a.events;
        var _b = this.state, selectedIndex = _b.selectedIndex, uniqueId = _b.uniqueId;
        var id = e.currentTarget.getAttribute("id");
        var index = parseInt(id.substring(id.length - 1, id.length), 10);
        if (key_press_1.KeyPress.enterIsPressed(e) || key_press_1.KeyPress.spaceIsPressed(e)) {
            if (index !== selectedIndex) {
                this.setState({ selectedIndex: index });
                if (events && events.onSelect) {
                    events.onSelect(data[index].value);
                }
            }
        }
        else if (key_press_1.KeyPress.leftArrowIsPressed(e)) {
            var newIndex = (index - 1) % data.length;
            var newId = uniqueId + "-" + newIndex;
            document.getElementById(newId).focus();
        }
        else if (key_press_1.KeyPress.rightArrowIsPressed(e)) {
            var newIndex = (index + 1) % data.length;
            var newId = uniqueId + "-" + newIndex;
            document.getElementById(newId).focus();
        }
    };
    ButtonGroup.prototype.onMouseLeave = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var hoverArr = this.state.hoverArr;
        hoverArr[index] = false;
        this.setState({ hoverArr: hoverArr.slice() });
    };
    ButtonGroup.prototype.onMouseOver = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var hoverArr = this.state.hoverArr;
        hoverArr[index] = true;
        this.setState({ hoverArr: hoverArr.slice() });
    };
    ButtonGroup.prototype.onMouseUp = function (e) {
        var id = e.currentTarget.id;
        var idSplit = id.split("-");
        var index = parseInt(idSplit[idSplit.length - 1], 10);
        var _a = this.props, data = _a.data, events = _a.events;
        var selectedIndex = this.state.selectedIndex;
        if (index !== selectedIndex) {
            this.setState({ selectedIndex: index });
            if (events && events.onSelect) {
                events.onSelect(data[index].value);
            }
        }
    };
    ButtonGroup.prototype.onTouchEnd = function () {
        this.setState({ isTouching: true });
    };
    ButtonGroup.prototype.updateWidth = function () {
        this.setState({ width: window.innerWidth });
    };
    ButtonGroup.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    ButtonGroup.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    ButtonGroup.prototype.render = function () {
        var _this = this;
        var _a = this.props, data = _a.data, options = _a.options, testId = _a.testId;
        var _b = this.state, hoverArr = _b.hoverArr, isTouching = _b.isTouching, selectedIndex = _b.selectedIndex, uniqueId = _b.uniqueId, width = _b.width;
        return (React.createElement("div", { className: "flex " + styles.buttonGroup, role: "radiogroup" }, data.map(function (item, index) { return (React.createElement("button", { "aria-checked": selectedIndex === index, className: "" + (selectedIndex === index
                ? options &&
                    (options.color === "black" || options.color === "white")
                    ? "btn-primary" + (options.color !== "white"
                        ? " " + styles.btnBlack + (hoverArr[index] && !isTouching
                            ? " " + styles.btnBlackHover
                            : "")
                        : "")
                    : "btn-primary-2 " + styles.btnCobalt + (hoverArr[index] && !isTouching
                        ? " " + styles.btnCobaltHover
                        : "")
                : "btn-secondary") + (options && options.color === "white"
                ? " on-dark " + styles.btnWhite + (hoverArr[index] && !isTouching
                    ? " " + styles.btnWhiteHover
                    : "") + (selectedIndex !== index ? " " + styles.btnWhiteUnSelected : "")
                : "") + (options && options.size === "large" && width >= 768
                ? " btn-large"
                : " btn-small") + " " + styles.btn + " pad-none " + (selectedIndex === index + 1 || hoverArr[index + 1]
                ? styles.noBorderRight
                : ""), "data-testid": testId, id: uniqueId + "-" + index, onKeyDown: _this.onKeyDown, onKeyUp: _this.onKeyUp, onMouseLeave: _this.onMouseLeave, onMouseOver: _this.onMouseOver, onMouseUp: _this.onMouseUp, onTouchEnd: _this.onTouchEnd, key: index, role: "radio", tabIndex: 0 }, item.name)); })));
    };
    return ButtonGroup;
}(React.PureComponent));
exports.default = ButtonGroup;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/ButtonGroup/ButtonGroup.js
// module id = 1746
// module chunks = 8